export const trimData = <T>(val: T): T => {
    if (typeof val === 'string') {
        return val.trim().replace(/\s+/g, ' ') as T;
    }

    if (Array.isArray(val)) {
        return val.map((item) => trimData(item)) as T;
    }

    if (val !== null && typeof val === 'object') {
        const result = {} as T;
        for (const key in val) {
            if (Object.prototype.hasOwnProperty.call(val, key)) {
                result[key] = trimData(val[key]);
            }
        }
        return result as T;
    }

    return val;
};
